"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = exports.verifySIWS = void 0;
const util_crypto_1 = require("@polkadot/util-crypto");
const util_1 = require("@polkadot/util");
const parseMessage_1 = require("./parseMessage");
/**
 * A util function that verifies that the `message` is signed by the `address` and matches the `signature`,
 * and returns a parsed SiwsMessage instance if the signature is valid.
 * It also wraps `await cryptoWaitReady` so you don't have to.
 */
const verifySIWS = async (message, signature, address, options = { disableAzeroId: false }) => {
    await (0, util_crypto_1.cryptoWaitReady)();
    const verification = (0, util_crypto_1.signatureVerify)(message, signature, address);
    if (!verification)
        throw new Error("SIWS Error: Invalid signature.");
    const siwsMessage = (0, parseMessage_1.parseMessage)(message);
    if (!options.disableAzeroId) {
        const validAzeroId = await siwsMessage.verifyAzeroId();
        if (!validAzeroId)
            throw new Error("SIWS Error: Invalid Azero ID.");
    }
    return siwsMessage;
};
exports.verifySIWS = verifySIWS;
/**
 * A util class that represents addresses as bytes except for when we need to display them to the user.
 * Allows us to confidently do stuff like equality checks, don't need to worry about SS58 encoding.
 */
class Address {
    bytes;
    constructor(bytes) {
        if (bytes.length !== 32)
            throw new Error("Address must be 32 bytes!");
        this.bytes = bytes;
    }
    static fromSs58(addressCandidate) {
        try {
            const bytes = (0, util_1.isHex)(addressCandidate)
                ? (0, util_1.hexToU8a)(addressCandidate)
                : (0, util_crypto_1.decodeAddress)(addressCandidate, false);
            return new Address(bytes);
        }
        catch (error) {
            // invalid address
            return false;
        }
    }
    static fromPubKey(pubKey) {
        const bytes = new Uint8Array((0, util_1.hexToU8a)(pubKey));
        if (bytes.length !== 32)
            return false;
        return new Address(bytes);
    }
    isEqual(other) {
        return this.bytes.every((byte, index) => byte === other.bytes[index]);
    }
    /* to generic address if chain is not provided */
    toSs58(ss58Prefix) {
        return (0, util_crypto_1.encodeAddress)(this.bytes, ss58Prefix);
    }
    toPubKey() {
        return (0, util_1.u8aToHex)(this.bytes);
    }
}
exports.Address = Address;
